/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { ROUTES } from '@kamernet/core/Routing/routes';
import { ListingsSearchCategory } from '@kamernet/core/Routing/routes/ListingsSearch';

import styles from './Content.module.css';

export const ContentCountryStudentHousing = () => {
  const { locale } = useIntl();
  const searchCategories = [ListingsSearchCategory.StudentHousing];

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Find Student Housing in the Netherlands
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Looking for student housing in the Netherlands? Explore Kamernet for a
        wide range of student accommodation in the Netherlands catering to
        various preferences and budgets. As more students choose to study in
        Europe, the demand for student residence in the Netherlands is
        increasing. Discover affordable student apartments, rooms, studios, and
        dormitories conveniently located near universities and campuses.
      </Typography>
      <Typography variant="h2" className={styles.title}>
        Find Student Apartments in the Netherlands
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Find student apartments in the Netherlands offering independence and comfort.
        Whether you're seeking a single room or a shared space, Kamernet
        provides options to suit your needs and budget. With basic amenities and
        proximity to academic institutions, student apartments in the Netherlands
        offer a conducive environment for focused studies.`}
      </Typography>
      <Typography variant="h2" className={styles.title}>
        Find Students Studios in the Netherlands
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Explore studio flats for students in the Netherlands for a balance of
        independence and convenience. From cozy units to spacious studios, find
        the perfect space to focus on your studies while enjoying on-site
        amenities. Whether furnished or unfurnished, student studio apartments
        in the Netherlands provide a dedicated living space for academic
        pursuits.
      </Typography>
      <Typography variant="h2" className={styles.title}>
        Find Student Dormitories in the Netherlands
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Student dormitories in the Netherlands offer budget-friendly communal
        living. Experience a vibrant community atmosphere while keeping costs
        low. Whether you prefer a social environment or a quiet study space,
        student dorms in the Netherlands offer diverse options to meet your
        needs.
      </Typography>
      <Typography variant="h2" className={styles.title}>
        Find Affordable Student Housing in the Netherlands
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Discover affordable student housing options in the Netherlands on
        Kamernet. From budget-friendly rooms to apartments, find accommodations
        that fit your financial constraints without compromising quality. With
        the rising cost of living, Kamernet helps students find cost-effective
        solutions for their housing needs.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        How to find student accommodation in the Netherlands?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        On Kamernet.nl you can filter and compare student accommodation in the
        Netherlands to find the right one based on your budget and preferences.
        You can also use our search filters to narrow down your search by
        location, availability, rental price and facilities.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        How much is student housing in the Netherlands?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Renting a student room in the the Netherlands can cost between €400 -
        €600 per month, while renting an apartment can cost anywhere from €750 -
        €1,250 per month. These prices are just estimates, and actual prices may
        differ.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        How much does it cost to live in the Netherlands as a student?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        The average cost of living for students in the Netherlands ranges
        between €1000 to €1500 including rent. However, monthly expenses for
        students can also vary based on their lifestyle choices and personal
        spending habits.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Useful Links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'almere', searchCategories },
          Locale.en,
        )}
      >
        Almere student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nijmegen', searchCategories },
          Locale.en,
        )}
      >
        Nijmegen student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hilversum', searchCategories },
          Locale.en,
        )}
      >
        Hilversum student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'eindhoven', searchCategories },
          Locale.en,
        )}
      >
        Eindhoven student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hoofddorp', searchCategories },
          Locale.en,
        )}
      >
        Hoofddorp student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zaandam', searchCategories },
          Locale.en,
        )}
      >
        Zaandam student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'arnhem', searchCategories },
          Locale.en,
        )}
      >
        Arnhem student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'tilburg', searchCategories },
          Locale.en,
        )}
      >
        Tilburg student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'enschede', searchCategories },
          Locale.en,
        )}
      >
        Enschede student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'amersfoort', searchCategories },
          Locale.en,
        )}
      >
        Amersfoort student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zeist', searchCategories },
          Locale.en,
        )}
      >
        Zeist student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'breda', searchCategories },
          Locale.en,
        )}
      >
        Breda student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'maastricht', searchCategories },
          Locale.en,
        )}
      >
        Maastricht student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nieuwegein', searchCategories },
          Locale.en,
        )}
      >
        Nieuwegein student housing
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'schiedam', searchCategories },
          Locale.en,
        )}
      >
        Schiedam student housing
      </NavLink.Anchor>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Vind studentenwoningen in Nederland
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Op zoek naar studentenwoning in Nederland? Verken Kamernet voor een
        breed scala aan studentenwoningen in heel Nederland, die voldoen aan
        verschillende voorkeuren en budgetten. Naarmate meer studenten ervoor
        kiezen om in het buitenland te studeren, neemt de vraag naar
        studentenhuis in Nederland toe. Ontdek betaalbare studenten
        appartementen, kamers, studio's en slaapzalen die gunstig gelegen zijn
        nabij universiteiten en campussen.`}
      </Typography>
      <Typography variant="h2" className={styles.title}>
        Vind studentenappartementen in Nederland
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Vind studentenappartementen in Nederland die onafhankelijkheid en
        comfort bieden. Of je nu op zoek bent naar een eenpersoonskamer of een
        gedeelde ruimte, Kamernet biedt opties die aan jouw behoeften en budget
        voldoen. Met basisvoorzieningen en de nabijheid van academische
        instellingen bieden studentenappartementen in Nederland een gunstige
        omgeving voor gericht studeren.`}
      </Typography>
      <Typography variant="h2" className={styles.title}>
        Vind studentenkamers in Nederland
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Huur studentenkamers in Nederland voor een gevoel van gemeenschap en
        betaalbaarheid. Kies uit een verscheidenheid aan opties, waaronder
        eenpersoonskamers en gedeelde accommodaties, ontworpen om vriendschappen
        en academisch succes te bevorderen. Kamernet biedt voordelige
        oplossingen voor studenten die op zoek zijn naar comfortabele en
        inclusieve woonsituaties.
      </Typography>
      <Typography variant="h2" className={styles.title}>
        {`Vinden studentenstudio's in Nederland`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Verken studio-appartementen voor studenten in Nederland voor een balans
        tussen onafhankelijkheid en gemak. Van gezellige eenheden tot ruime
        studio's, vind de perfecte ruimte om je te concentreren op je studie
        terwijl je geniet van aanwezige faciliteiten. Of ze nu gemeubileerd of
        ongemeubileerd zijn, bieden studentenstudio's in Nederland een
        toegewijde leefruimte voor academische doelen.`}
      </Typography>
      <Typography variant="h2" className={styles.title}>
        Vind goedkope studentenwoningen in Nederland
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Ontdek betaalbare studentenwoningen in Nederland op Kamernet. Van
        goedkope kamers tot appartementen, vind woningen die aan je financiële
        eisen voldoen zonder in te leveren op kwaliteit. Met de stijgende kosten
        van levensonderhoud helpt Kamernet studenten om betaalbare oplossingen
        te vinden voor hun woonwensen.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Hoe vind je studentenwoningen in Nederland?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Op kamernet.nl kun je studentenwoningen in Nederland filteren en
        vergelijken om de juiste te vinden op basis van je budget en voorkeuren.
        Je kunt ook onze zoekfilters gebruiken om je zoekopdracht te verfijnen
        op locatie, beschikbaarheid, huurprijs en voorzieningen.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Hoeveel kost studentenwoningen in Nederland?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Het huren van een studentenkamer in Nederland kan tussen de €400 en €600
        per maand kosten, terwijl het huren van een appartement ergens tussen de
        €750 en €1,250 per maand kan kosten. Deze prijzen zijn slechts
        schattingen en kunnen verschillen.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Hoeveel kost het om als student in Nederland te wonen?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        De gemiddelde kosten van levensonderhoud voor studenten in the
        Netherlands liggen tussen de €1000 en €1500, inclusief huur. De
        maandelijkse uitgaven voor studenten kunnen echter ook variëren op basis
        van levensstijlkeuzes en persoonlijke uitgavenpatronen.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Handige links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'almere', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Almere
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nijmegen', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Nijmegen
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hilversum', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Hilversum
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'eindhoven', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Eindhoven
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hoofddorp', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Hoofddorp
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zaandam', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Zaandam
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'arnhem', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Arnhem
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'tilburg', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Tilburg
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'enschede', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Enschede
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'amersfoort', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Amersfoort
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zeist', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Zeist
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'breda', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Breda
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'maastricht', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Maastricht
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nieuwegein', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Nieuwegein
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'schiedam', searchCategories },
          Locale.nl,
        )}
      >
        Studentenwoning Schiedam
      </NavLink.Anchor>
    </React.Fragment>
  );
};
